import React from 'react';
import { block } from '../utils/cn';
import { LayoutDirection } from './constants';
import { ShareList } from './ShareList/ShareList';
import { Popover } from '../Popover';
import { Icon } from '../Icon';
import { Share } from '../icons';
import './ShareTooltip.css';
const b = block('share-tooltip');
export const shareTooltipDefaultProps = {
    iconSize: 16,
    socialNets: ShareList.defaultProps.socialNets,
    withCopyLink: true,
    useWebShareApi: false,
    placement: ['bottom-end'],
    openByHover: true,
    autoclosable: true,
    closeDelay: 300,
    direction: LayoutDirection.Row,
};
export class ShareTooltip extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = async (event) => {
            const { url, title, text, useWebShareApi, handleMetrika } = this.props;
            if (handleMetrika) {
                handleMetrika();
            }
            if (useWebShareApi && navigator && typeof navigator.share === 'function') {
                await navigator.share({ url, title, text });
                event.preventDefault();
                return false;
            }
            return true;
        };
    }
    render() {
        const { url, title, text, socialNets, withCopyLink, useWebShareApi, placement, openByHover, autoclosable, closeDelay, iconSize, iconClass, tooltipClassName, switcherClassName, className, direction, customIcon, buttonTitle, children, } = this.props;
        const content = (React.createElement(ShareList, { url: url, title: title, text: text, socialNets: socialNets, withCopyLink: withCopyLink, direction: direction }, children));
        return (React.createElement(Popover, { placement: placement, hasArrow: false, openOnHover: openByHover && !useWebShareApi, autoclosable: autoclosable, delayClosing: closeDelay, content: content, className: b(null, className), tooltipClassName: b('tooltip', tooltipClassName), onClick: this.handleClick },
            React.createElement("div", { className: b('container', switcherClassName) },
                React.createElement("div", { className: b('icon-container') },
                    React.createElement(Icon, { data: customIcon ? customIcon : Share, size: iconSize, className: b('icon', iconClass) })),
                Boolean(buttonTitle) && React.createElement("div", { className: b('title') }, buttonTitle))));
    }
}
ShareTooltip.defaultProps = shareTooltipDefaultProps;
